
import { View } from "@/models/view";
import { Highlight } from "@/utils/views/highlight";
import Vue from "vue";
import AppHighlightEdit from "./HighlightEdit.vue";
import { getModel, Model } from "@/utils/models/model";
import { Browse } from "@/models/browse";
import { BrowseService } from "@/services";

export default Vue.extend({
	data(){
		return {
			toEditHighlight: null as null | Highlight,
			toEditIndex: -1
		};
	},
	props: {
		view: {
			type: Object as ()=>View,
			required: true
		},
	},
	computed: {
		model():Model{
			return getModel(this.view.Table);
		},
		browse(): Browse | null {
			return BrowseService.getBrowseWithoutViewSettings(this.view.BrowseID);
		},
	},
	methods: {
		addClicked(){
			this.view.Highlights.push(new Highlight());
		},
		removeHighlight(i:number){
			this.view.Highlights.splice(i,1);
		},
		onEditCondition(i:number){
			this.toEditIndex = i;
			this.toEditHighlight = this.view.Highlights[i];
		},
		onHighlightInput(highlight:Highlight){
			if (this.toEditIndex < 0) return;
			this.view.Highlights[this.toEditIndex] = highlight;
		}
	},
	components: {
		AppHighlightEdit
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
